import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-services-movi-link',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './services-movi-link.component.html',
  styleUrl: './services-movi-link.component.css'
})
export class ServicesMoviLinkComponent {
  services: any | [] = [
    {
      nombre: 'Consulta médica',
      imagen: 'stetoscopio.svg',
    },
    {
      nombre: 'Toma de muestras',
      imagen: 'tomademuestra.svg',
    },
    {
      nombre: 'Electrocardiograma',
      imagen: 'electrocardiograma.svg',
    },
    {
      nombre: 'Colocación de inyección',
      imagen: 'inyeccion.svg',
    },
    {
      nombre: 'Ecografía',
      imagen: 'ecografia.svg',
    },
    {
      nombre: 'Monitoreo',
      imagen: 'Monitoreo.svg',
    },
    {
      nombre: 'Colocación de suero',
      imagen: 'suero.svg',
    },
    {
      nombre: 'Prueba de alergias',
      imagen: 'alergias.svg',
    },
    {
      nombre: 'Holter',
      imagen: 'holter.svg',
    },
    {
      nombre: 'Terapia física',
      imagen: 'terapiafisica.svg',
    },
    {
      nombre: 'Nebulizaciones',
      imagen: 'nebulizaciones.svg',
    },
    {
      nombre: 'Rayos X',
      imagen: 'rayosX.svg',
    }
  ];



}
